@if (hasAiPermission() && hasAiAssistantEnabled()) {
  @if ('lg' | up) {
    <!-- Desktop: small floating window or full-screen overlay -->
    @if (aiService.panelSize() === 'small') {
      <div cdkDrag class="fixed bottom-[60px] right-6 z-50" [cdkDragFreeDragPosition]="dragPosition()" (cdkDragEnded)="onDragEnded($event)">
        <app-ai-assistant-window
          appEdgeResize
          [style.width.px]="windowSize()?.width"
          [style.height.px]="windowSize()?.height"
          (sizeChange)="onWindowSizeChange($event)"
        />
      </div>
    } @else if (aiService.panelSize() === 'fullscreen') {
      <div class="fixed inset-0 z-50 bg-background-fixed">
        <app-ai-assistant-fullscreen class="h-full w-full" />
      </div>
    }
  } @else {
    <!-- Mobile: always full-screen when panel is open (no fullscreen mode on mobile) -->
    @if (aiService.panelSize() !== 'closed') {
      <div class="fixed inset-0 z-50">
        <app-ai-assistant-window />
      </div>
    }
  }
}
